import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from "moment";

import style from "./style.scss";

import SelectBox from '../SelectBox';

import marketingListItemTypes from "../../services/constants/marketingListItemTypes";

import * as marketingActions from '../../actions/marketingPage';

class MarketingListItem extends Component {

    render(){
        let name,
            type,
            moduleName,
            venue = null,
            eventStartDate;

        if(this.props.item.marketable_type === marketingListItemTypes.course.className){
            name = this.props.item.marketable.name;
            type = "Course"
            moduleName = this.props.item.marketable.module && this.props.item.marketable.module.name;
        }else{
            name = this.props.item.marketable.course_name;
            type = "Event"
            moduleName = this.props.item.marketable.course.module && this.props.item.marketable.course.module.name;
            venue = this.props.item.marketable.venue;
            if(this.props.item.marketable.multiple_days){
                eventStartDate = this.props.item.marketable.multiple_days_events[0].start_date;
            }else{
                eventStartDate = this.props.item.marketable.start_date;
            }
        }

        return (
            <div className={style['marketing-list-item']}>
                <div className={style['item-info']}>
                    <span className={style['item-type']}>{type}</span>
                    <p className={style['item-name']}>{name}</p>
                    {type === "Event" && (
                        <div>
                            <p>Venue: {venue && venue.address.address_1} {venue && venue.address.post_code}</p>
                            <p>Date: {moment(eventStartDate).format('Do MMMM Y')}</p>
                        </div>
                    )}
                    <span className={style['item-module']}>{moduleName}</span>
                </div>
                <div className={style['item-controls']}>
                    <a onClick={() => {this.props.removeItem(this.props.item.id)}}>Remove</a>
                    <SelectBox
                        className={style['change-item-order']}
                        onChange={(e) => this.props.reOrder(parseInt(e.target.value), this.props.item.id)}
                        value={this.props.item.position}
                        defaultValue={this.props.item.position}
                    >
                        <option>Position</option>
                        {this.props.allItems.map(pos => (
                            <option
                                key={pos.id}
                            >{pos.position}</option>
                        ))}
                    </SelectBox>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        reOrder(value, itemID){
            dispatch(marketingActions.reOrderMarketingItems(value, itemID));
        },
        removeItem(id){
            dispatch(marketingActions.removeMarketingItem(id));
        }
    }
}

export default connect(null, mapDispatchToProps)(MarketingListItem);


// WEBPACK FOOTER //
// ./components/MarketingListItem/index.js